document.addEventListener("DOMContentLoaded", function () {
	let hasVideoStartedOnce = false;

	var wrapper = document.querySelector(".size-guide-video-wrapper");
	var video = document.getElementById("size-guide-video");
	var playBtn = document.getElementById("size-guide-video-play-btn");
	if (!wrapper || !video || !playBtn) return;

	function updateState() {
		if (video.paused) {
			wrapper.classList.add("paused");
			wrapper.classList.remove("playing");
			playBtn.setAttribute("aria-label", "Play");
		} else {
			wrapper.classList.remove("paused");
			wrapper.classList.add("playing");
			playBtn.setAttribute("aria-label", "Pause");
		}
	}

	playBtn.addEventListener("click", function () {
		if (hasVideoStartedOnce) {
			return;
		}
		hasVideoStartedOnce = true;
		video.setAttribute("controls", "controls");
		video.play();
		updateState();
	});

	updateState();
});
